import { render, staticRenderFns } from "./userJoininDrop.vue?vue&type=template&id=34bda014&scoped=true&"
import script from "./userJoininDrop.vue?vue&type=script&lang=js&"
export * from "./userJoininDrop.vue?vue&type=script&lang=js&"
import style0 from "./userJoininDrop.vue?vue&type=style&index=0&id=34bda014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bda014",
  null
  
)

export default component.exports